import { ListboxOption } from '@headlessui/react'

import type { InputSelectMultiOptionProps } from './type'

import { InputSelectMultiOptionContent } from '@/components/ui/input/select/elements'

import { isSelected } from '../util'

export const InputSelectMultiOption = ({
  option,
  selectedOptions,
}: InputSelectMultiOptionProps) => {
  return (
    <ListboxOption value={option}>
      {({ active }) => {
        return (
          <InputSelectMultiOptionContent
            active={active}
            selected={isSelected(option, selectedOptions)}
            option={option}
          />
        )
      }}
    </ListboxOption>
  )
}

InputSelectMultiOption.displayName = 'InputSelectMultiOption'
